module.exports = __webpack_public_path__ + "img/delete.199c6967.png";